// @ts-check

import WebappClientConnect from '../Query/webAppClientComponent'

const locations = require('../../testdata/locations.json')
const _webappClient = new WebappClientConnect.WrappedComponent()

const formToSubmitData = (form) => {
  const queryh = {
    "project_name": form.buildingInfo.project_name,
    "location": form.buildingInfo.location,
    "units": form.buildingInfo.units,
    "currency": form.costs.currency,
    "plot_width": parseFloat(form.buildingInfo.plot_width),
    "plot_length": parseFloat(form.buildingInfo.plot_length),
    "flat_types": form.buildingInfo.unit_types.map(ut => {
      return {
        "id": ut.id,
        "name": ut.name,
        "floor_area": ut.floor_area,
        "cost": parseFloat(ut.cost_sqr_meter),
        "income": parseFloat(ut.revenue_sqr_meter),
        "mix_value": ut.mixerVal
      }
    }),
    "ratio_by": form.buildingInfo.mix_by,
    "floor_height": form.buildingInfo.floor_height,
    "num_of_storeys_buildings": [form.buildingInfo.floors_number],
    "core_distance": form.buildingInfo.distance_between_vertical_cores,
    "building_type": "high",
    "flat_depth": form.buildingInfo.flat_depth,
    "corridor_width": form.buildingInfo.corridor_width,

    "exterior_walls": form.sustainability.materials.find(m => m.prefix === 'EW').material,
    "ground_floor": form.sustainability.materials.find(m => m.prefix === 'GF').material,
    "roof": form.sustainability.materials.find(m => m.prefix === 'RF').material,
    "internal_walls": form.sustainability.materials.find(m => m.prefix === 'IP').material,
    "party_wall": form.sustainability.materials.find(m => m.prefix === 'PW').material,
    "floor_ceiling_slabs": form.sustainability.materials.find(m => m.prefix === 'FC').material,
    "windows": form.sustainability.materials.find(m => m.prefix === 'WD').material,

    "show_life_cycle_analysis": form.sustainability.show_life_cycle_analysis, // TODO: crashes on false - schwarts will fix
    "heating_system": form.sustainability.heating_systems,
    "cooling_system": form.sustainability.cooling_systems,
    "heating_conversion_factor_kg_co2_kwh": parseFloat(form.sustainability.heating_conversion_factor),
    "cooling_conversion_factor_kg_co2_kwh": parseFloat(form.sustainability.cooling_conversion_factor),
    "lighting_conversion_factor_kg_co2_kwh": parseFloat(form.sustainability.lighting_conversion_factor),
    "assumed_buildings_life_years": parseFloat(form.sustainability.assumed_building_life_years),
    "results_percentace": 0, // constant, leaving it like that for now
    "soft_cost": [
      {
        "architect": parseFloat(form.costs.architect),
        "quantity_surveyor": parseFloat(form.costs.quantity_surveyor),
        "structural_engineer": parseFloat(form.costs.structural_engineer),
        "mechanical_engineer": parseFloat(form.costs.mechanical_engineer),
        "project_manager": parseFloat(form.costs.project_manager),
        "licensing": parseFloat(form.costs.licensing),
        "marketing": parseFloat(form.costs.marketing),
        "other": parseFloat(form.costs.soft_other)
      }
    ],
    "pre_construction": [
      {
        "demolition": parseFloat(form.costs.demolition),
        "site_preparation": parseFloat(form.costs.site_preparation),
        "infrastructure": parseFloat(form.costs.infrastructure),
        "excavation": parseFloat(form.costs.excavation),
        "others": parseFloat(form.costs.pre_construction_other)
      }
    ],
    "energy_calculations": {
      'hdd': locations[form.buildingInfo.location]?.hdd || 0,
      'cdd': locations[form.buildingInfo.location]?.cdd,
      'solar': locations[form.buildingInfo.location]?.solar
    }
  }

  const queryl = {
    "project_name": form.buildingInfo.project_name,
    "location": form.buildingInfo.location,
    "units": form.buildingInfo.units,
    "currency": form.costs.currency,
    "plot_width": parseFloat(form.buildingInfo.plot_width),
    "plot_length": parseFloat(form.buildingInfo.plot_length),
    "flat_types": form.buildingInfo.unit_types.map(ut => {
      return {
        "id": ut.id,
        "name": ut.name,
        "flat_depth": ut.flat_depth,
        "floor_area": ut.floor_area,
        "house_width": +ut.house_width,
        "storeys": +ut.storeys,
        "cost": parseFloat(ut.cost_sqr_meter),
        "income": parseFloat(ut.revenue_sqr_meter),
        "mix_value": ut.mixerVal
      }
    }),
    "ratio_by": form.buildingInfo.mix_by,
    "floor_height": form.buildingInfo.floor_height,

    "minimal_block_width": +form.buildingInfo.minimal_block_width,
    "minimal_block_depth": form.buildingInfo.minimal_block_depth,

    "building_type": "low",
    "distance_from_road": form.buildingInfo.distance_from_road,
    "road_width": form.buildingInfo.road_width,

    "exterior_walls": form.sustainability.materials.find(m => m.prefix === 'EW').material,
    "ground_floor": form.sustainability.materials.find(m => m.prefix === 'GF').material,
    "roof": form.sustainability.materials.find(m => m.prefix === 'RF').material,
    "internal_walls": form.sustainability.materials.find(m => m.prefix === 'IP').material,
    "party_wall": form.sustainability.materials.find(m => m.prefix === 'PW').material,
    "floor_ceiling_slabs": form.sustainability.materials.find(m => m.prefix === 'FC').material,
    "windows": form.sustainability.materials.find(m => m.prefix === 'WD').material,

    "show_life_cycle_analysis": form.sustainability.show_life_cycle_analysis, // TODO: crashes on false - schwarts will fix
    "heating_system": form.sustainability.heating_systems,
    "cooling_system": form.sustainability.cooling_systems,
    "heating_conversion_factor_kg_co2_kwh": parseFloat(form.sustainability.heating_conversion_factor),
    "cooling_conversion_factor_kg_co2_kwh": parseFloat(form.sustainability.cooling_conversion_factor),
    "lighting_conversion_factor_kg_co2_kwh": parseFloat(form.sustainability.lighting_conversion_factor),
    "assumed_buildings_life_years": parseFloat(form.sustainability.assumed_building_life_years),
    "results_percentace": 0, // constant, leaving it like that for now
    "soft_cost": [
      {
        "architect": parseFloat(form.costs.architect),
        "quantity_surveyor": parseFloat(form.costs.quantity_surveyor),
        "structural_engineer": parseFloat(form.costs.structural_engineer),
        "mechanical_engineer": parseFloat(form.costs.mechanical_engineer),
        "project_manager": parseFloat(form.costs.project_manager),
        "licensing": parseFloat(form.costs.licensing),
        "marketing": parseFloat(form.costs.marketing),
        "other": parseFloat(form.costs.soft_other)
      }
    ],
    "pre_construction": [
      {
        "demolition": parseFloat(form.costs.demolition),
        "site_preparation": parseFloat(form.costs.site_preparation),
        "infrastructure": parseFloat(form.costs.infrastructure),
        "excavation": parseFloat(form.costs.excavation),
        "others": parseFloat(form.costs.pre_construction_other)
      }
    ],
    "energy_calculations": {
      'hdd': locations[form.buildingInfo.location]?.hdd || 0,
      'cdd': locations[form.buildingInfo.location]?.cdd,
      'solar': locations[form.buildingInfo.location]?.solar
    }
  }
  return form.buildingInfo.building_type === "H" ? queryl : queryh
  //return mockRequest
}

export const sendForm = async (form) => {
  const submitData = formToSubmitData(form)
  const solutions = await _webappClient.fetchSolutions(submitData)
  return solutions
}
